import React, { Component } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import { TextField, SelectField } from '../../components'
import { Alert, Button, Col, Row, SubmitRow } from '../../elements'

import validate from './validate'

class ClientConfigForm extends Component {
    static propTypes = {
        onSubmit: PropTypes.func,
    }

    render() {
        const { isSubmiting, handleSubmit, onSubmit, clients, initialValues } = this.props
        const clientIdDisabled = Boolean(get(initialValues, 'clientId'))
        let clientIds = null
        if (clients) {
            clientIds = clients.map(client => client.clientId);
        } else if (initialValues) {
            clientIds = [initialValues.clientId]
        }

        if (clientIds == null) {
            clientIds = ['']
        }

        return (
            <form onSubmit={handleSubmit(onSubmit)}>
                <Field
                    name="clientId"
                    label="Client Id"
                    options={clientIds}
                    disabled={isSubmiting}
                    component={SelectField}
                    disabled={clientIdDisabled}
                />
                <Field
                    name="liveViewEnabled"
                    label="Live View Enabled"
                    options={[{ label: "True", value: true }, { label: "False", value: false }]}
                    disabled={isSubmiting}
                    component={SelectField}
                    className="field"
                />
                <Field
                    name="visitCalculationEnabled"
                    label="Visit Calculation Enabled"
                    options={[{ label: "True", value: true }, { label: "False", value: false }]}
                    disabled={isSubmiting}
                    component={SelectField}
                    className="field"
                />

                <Field
                    name="liveVisitEnabled"
                    label="Live Visit Enabled"
                    options={[{ label: "True", value: true }, { label: "False", value: false }]}
                    disabled={isSubmiting}
                    component={SelectField}
                    className="field"
                />

                <Field
                    name="liveVisitGracePeriod"
                    label="Live Visit Grace Period"
                    disabled={isSubmiting}
                    component={TextField}
                    className="field"
                />

                <Field
                    name="liveVisitMergePeriod"
                    label="Live Visit Merge Period"
                    disabled={isSubmiting}
                    component={TextField}
                    className="field"
                />
                <SubmitRow>
                    <Row type="flex" gutter={20}>
                        <Col>
                            <Button htmlType="submit" type="primary" wide>
                                {clientIdDisabled ? 'Save' : 'Create'}
                            </Button>
                        </Col>
                    </Row>
                </SubmitRow>
            </form>
        )
    }
}

export default reduxForm({
    form: 'client-config-form',
    validate,
})(ClientConfigForm)



// WEBPACK FOOTER //
// ./src/smart-components/client-config-form/index.js